/**
 * Shipping benefit (toimitusetu): fetched once the app is mounted (refreshed every 5 min on use), and the cart products
 * matching the rule's product filter are refreshed whenever the cart products change.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const store = useShippingBenefitStore()
    const cartStore = useCartStore()
    store.fetchShippingBenefit()
    watch(() => cartStore.items.map(item => item.sku).join(','), () => store.refreshMatchingSkus())
  })
})
